var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428ecde1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 423
// module chunks = 15